import React, { useContext, useState, useEffect } from "react";
import { AccordionContext } from "./AccordionContainer";
import styled from "styled-components";
import { statusStyles } from "../styles";
import PropTypes from "prop-types";

const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  margin-right: 15px;
  transform: rotate(${(props) => props.rotate}deg);
  transition: transform 0.5s ease-in-out, background-color 0.5s ease-in-out;
`;

const styleSheet = {
  circle: {
    Success: {
      backgroundColor: "rgb(32,195,116)",
    },
    Pending: {
      backgroundColor: "rgb(115,141,237)",
    },
    Skipped: {
      backgroundColor: "rgb(177, 156, 215)",
    },
    Fail: {
      backgroundColor: "rgb(224,79,79)",
    },
    PendingUnallowed: {
      backgroundColor:
        statusStyles.PendingUnallowed.circleNumberBackgroundColor,
    },
  },
  circleDigitDiv: {
    height: "auto",
    width: "100%",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "3px",
  },
};

const CircleNumber = ({ number, status }) => {
  const { accordionData } = useContext(AccordionContext);
  const displayId = accordionData[number - 1].displayId;

  const [rotation, setRotation] = useState(0);
  const [prevStatus, setPrevStatus] = useState(status);

  useEffect(() => {
    if (prevStatus !== status) {
      setRotation((rotation) => rotation + 360);
      setPrevStatus(status);
    }
  }, [status, prevStatus]);

  return (
    <Circle color={styleSheet.circle[status].backgroundColor} rotate={rotation}>
      <div style={styleSheet.circleDigitDiv}>{displayId}</div>
    </Circle>
  );
};

CircleNumber.propTypes = {
  number: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
};

export default CircleNumber;
